import React from 'react';
import PropTypes from 'prop-types';
import { LOGIN } from '../../../constants';
import { Link } from 'react-router-dom';

import alertIcon from 'assets/img/alert-icon.svg';

class EnterUserName extends React.Component {
  static propTypes = {
    fetchMethods: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    isResetError: PropTypes.bool
  }

    state = {
      username: false,
      userNameError: false,
      isSubmitted: false
    }

    handleUserChange = (event) => {
      this.setState({
        [event.target.name]: event.target.value,
        userNameError: false,
        isSubmitted: false
      });
    }

    SubmitUsername = (event) => {
      event.preventDefault();
      this.props.fetchMethods({ UserName: this.state.username });
      this.setState({ isSubmitted: true });
    }

    render () {
      const isUnknownUserError = this.props.errorMessage === 'Not Found';
      return (
        <React.Fragment>
          <form>
            <div className='login-content'>
              <div className='password-container'>
                <div className='login-bold-header'>
                Forgot Your Password?
                </div>
                <div className='login-body-text'>
                  {LOGIN.FORGOT_YOUR_PASSWORD}
                </div>
                <div className='login-input-header'>
                Username
                </div>
                <div className='input-message-alert'>
                  <input autoFocus type='text' id='login-form-email' className='login-form' name='username' autoComplete='off' onChange={this.handleUserChange} />
                </div>
                { !!isUnknownUserError && this.state.isSubmitted && this.props.isResetError &&
                <div className='alert-message fade-in'>
                  <div><img className='alert-icon' src={alertIcon} /></div>
                  <div>{LOGIN.USERNAME_ERROR}</div>
                </div>
                }
                <div className='login-body-text login-disclaimer'>
                  {LOGIN.MESSAGING_DISCLAIMER}
                </div>
              </div>
              <div className='bottom-button-wrapper'>
                <div>
                  <Link to='/login'>
                    <button className='login-back-btn' type='reset'>
                  Back
                    </button>
                  </Link>
                </div>
                <div className=' push'>
                  <button
                    disabled={!this.state.username}
                    onClick={this.SubmitUsername}
                    className='login-primary-button' type='submit'>
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </form>
        </React.Fragment>
      );
    }
}

export default EnterUserName;
